export default __webpack_public_path__ + "8ea281f9d79ce35e9a9f1bcf9e91f667.png";